import {memo, useMemo} from "react";
import useStyles from "./useStyles";
import StylizedMaterialReactTable from "../../StylizedComponents/StylizedMaterialReactTable";

export const GeozoneIntersections = memo(({ dataForTable, selectedGeozone }) => {

    const classes = useStyles();

    const columns = useMemo(
        () => [
            {
                accessorKey: 'tracker.value', //access nested data with dot notation
                header: 'Объект',
            },
            {
                accessorKey: 'start.value',
                header: 'Время захода',
            },
            {
                accessorKey: 'end.value', //normal accessorKey
                header: 'Время выхода',
            },
            {
                accessorKey: 'timezone.value', //normal accessorKey
                header: 'Таймзона',
            },
            {
                accessorKey: 'duration.value',
                header: 'Продолжительность нахождения',
            },
        ],
        [])

    const rows = useMemo(() => {
        return dataForTable.data
    }, [dataForTable.data])

    const tablesStylesOptions = {
        maxHeightContainer: "35vh",
        tableCell: {
            minWidth: "15%",
        }
    }

    const tableOptions = {
        columns,
        data: rows,
        enableStickyHeader: true,
        enableColumnResizing: true,
        enableColumnOrdering: true,
        columnResizeMode: 'onChange', //default
        enableFullScreenToggle: false,
        positionPagination: 'top',
    }

    return (
        <>
            <div>
                <div className={classes.geoZoneNameWrapper}>
                    <span className={classes.geoZoneName}>{selectedGeozone?.name}</span>
                </div>
                <StylizedMaterialReactTable
                    tableOptions={tableOptions}
                    tablesStylesOptions={tablesStylesOptions}
                />
            </div>
        </>
    )
})
